import { Type } from 'typescript'
import { BatchResponseItem } from '../api/oData/responses'
import { ApiError } from '../model/apiError'
import { ServiceBatchResponse } from '../model/serviceBatchResponse'
import { ServiceResponse } from '../model/serviceResponse'
import { BatchErrorResponse } from '../api/Pioneer/model/responses/batch.response'

export function createSuccessServiceResponse<Type>(data: Type): ServiceResponse<Type> {
  return { success: true, error: undefined, data: data }
}

export const createErrorServiceResponse = (error: ApiError): ServiceResponse<undefined> => {
  return {
    success: false,
    error: {
      id: error?.id,
      code: error.statusCode ? error.statusCode.toString() : '',
      message: error.errors && error.errors.length > 0 ? `${error.errors[0]}` : undefined
    },
    data: undefined
  }
}

//#region BATCH

export const createSuccessServiceBatchResponse = (data?: any | undefined): ServiceBatchResponse => {
  return { success: true, errors: null, data: data }
}

export const createErrorServiceBatchResponse = (
  errors: BatchResponseItem[]
): ServiceBatchResponse => {
  return {
    success: false,
    errors:
      errors !== null
        ? errors.map(error => {
            return {
              id: error.id,
              code: error.status ? error.status.toString() : '',
              message: error.body.value ? error.body.value.map(x => x.errorCode).join(',') : ''
            }
          })
        : null,
    data: undefined
  }
}

export const createPioneerErrorServiceBatchResponse = (
  errors: BatchErrorResponse[]
): ServiceBatchResponse => {
  return {
    success: false,
    errors:
      errors !== null
        ? errors.map(error => {
            return {
              code: error.code ? error.code.toString() : '',
              message: error.message ? error.message : ''
            }
          })
        : null,
    data: undefined
  }
}

export const createGenericErrorServiceBatchResponse = (error: ApiError): ServiceBatchResponse => {
  return {
    success: false,
    errors: null,
    data: undefined
  }
}

//#endregion
